import React from 'react';

var AppStore = require('./../store/appStore');
const imgBlank = require("../../../img/blank.gif");

module.exports = React.createClass({

  DEFAULT_LANG: 'en-GB',

  propTypes: {
    defaultValue: React.PropTypes.string,
    onChangeLanguage: React.PropTypes.func,
    menuClass: React.PropTypes.string
  },

  getDefaultProps(){
    return {
      defaultValue: "",
      menuClass: ""
    }
  },

  getInitialState(){
    return {
      languageCode: this.props.defaultValue || this.DEFAULT_LANG
    }
  },

  componentWillReceiveProps(nextProps){
    this.setState({
      languageCode: nextProps.defaultValue || this.DEFAULT_LANG
    });
  },

  getLanguage(){
    return this.state.languageCode;
  },

  render(){
    var {className, menuClass} = this.props;
    var languages = AppStore.getAvailableLanguages();

    var controlClass = className || "language-dropdown-list",
      menu = menuClass + " dropdown-menu";

    return (
      <ul className={controlClass}>
        <li>
          <a className="dropdown-toggle" href="#" data-toggle="dropdown">
            {this._renderCurrentLang()}
            <i className="flag-toggle fa fa-angle-down"/></a>
          <ul className={menu}>
            {languages.map(this._getFlag)}
          </ul>
        </li>
      </ul>
    )
  },

  _renderCurrentLang(){
    var {languageCode} = this.state;
    var language = this._getLang(languageCode);
    return !language
      ? null
      : [
      <img key='flag'
           src={imgBlank}
           className={classnames(['flag', 'flag-'+language.key])}
      />,
      <span className={'flag-title'} key='title'>&nbsp;{language.title}&#x200E;&nbsp;</span>
    ];
  },

  _getLang(code){
    return AppStore.getLanguageByCode(code);
  },

  _getFlag(_lang, idx){
    var {languageCode} = this.state;

    return (
      <li key={idx}
          className={ classnames({active: _lang.code == languageCode}) }>
        <a onClick={this._selectLanguage.bind(this, _lang)}>
          <img src={imgBlank}
               className={classnames(['flag', 'flag-'+_lang.key])}
          />
          <span className={'flag-value'}>&nbsp;{_lang.title}&#x200E;</span>
        </a>
      </li>
    )
  },

  _selectLanguage: function (language) {
    var {onChangeLanguage} = this.props;

    this.setState({
      languageCode: language.code
    });

    if (typeof onChangeLanguage == "function") {
      onChangeLanguage(language);
    }
  }

});
